import { Grid, Bones } from '@simplywallst/ui-core';

export const RecentInsightsSkelecton = () => (
  <>
    <Grid paddingBottom="x0_5" paddingTop="x1_25">
      <Bones maxWidth="100%" minHeight="150px" />
    </Grid>
    <Grid paddingBottom="x0_5" paddingTop="x1_25">
      <Bones maxWidth="100%" />
      <Bones maxWidth="100%" />
    </Grid>
    <Grid paddingBottom="x0_5" paddingTop="x1_25">
      <Bones maxWidth="100%" />
      <Bones maxWidth="100%" />
    </Grid>
    <Grid paddingBottom="x0_5" paddingTop="x1_25">
      <Bones maxWidth="100%" />
      <Bones maxWidth="100%" />
    </Grid>
  </>
);
